// Catégories professionnelles pour lesquelles Neoliane n'ouvre pas les garanties
// d'arrêt de travail / invalidité (ITT / IPT / IPP) : ces garanties indemnisent
// une perte de capacité de gain, sans objet pour un assuré sans activité.
// Ces catégories correspondent aux statuts Neoliane 19 (Retraité cadre),
// 20 (Retraité non-cadre) et 21 (Sans profession) — cf.
// map_statut_professionnel_for_neoliane dans backendCAC/app/schemas/map.py.
//
// ⚠️ L'API Neoliane ne contrôle pas cette règle en tarification
// (IdTypeOperation=1) : elle renvoie des prix incluant l'IPT. Le refus n'arrive
// qu'à l'importation (IdTypeOperation=2), au moment de la souscription. On masque
// donc les produits en amont pour ne pas afficher un tarif non souscriptible.
export const NEOLIANE_ITT_IPT_IPP_FORBIDDEN_CATEGORIES = new Set<string>([
  'INTERMITTENT', // Étudiant / Intermittent / Saisonnier
  'CHOMAGE', // Chômage / en recherche d'emploi
  'SANS_PROFESSION', // Sans profession
  'RETRAITE_CADRE', // Retraité cadre
  'RETRAITE_NONCADRE', // Retraité non cadre
]);

/**
 * Indique si une catégorie professionnelle interdit les garanties ITT/IPT/IPP
 * chez Neoliane. La valeur est normalisée (trim + majuscules) avant comparaison.
 */
export function isNeolianeCategoryForbiddenForIttIptIpp(
  category?: string | null
): boolean {
  const normalized = String(category ?? '').trim().toUpperCase();
  return NEOLIANE_ITT_IPT_IPP_FORBIDDEN_CATEGORIES.has(normalized);
}
